<app-standard-bottom-sheet [(isOpen)]="isOpen"
                           [isFullScreen]="true"
                           [preventOverlayClose]="true"
                           [hasFooter]="false"
                           (overlayClick)="onCancel()"
                           testId="previous-issue-container">
  <div class="previous-issue-container"
       data-testid="previous-issue-container-body">

    <div class="step-track"
         [style.transform]="trackTransform()">

      <div class="step-panel"
           [attr.inert]="step() === 'list' ? null : ''">
        <div class="list-step"
             data-testid="previous-issue-container-list-step">
          <app-section-header title="Select the issues you see on-site:"
                              align="center"
                              testId="previous-issue-container-list-header" />

          @if (showListError()) {
            <app-input-error class="previous-issue-list-error"
                             data-testid="previous-issue-container-list-error">
              Select at least one issue to continue.
            </app-input-error>
          }

          <div class="issue-cards"
               data-testid="previous-issue-container-cards">
            @for (card of issues(); track card.issue.identifier) {
              <app-issue-card [issue]="card.issue"
                              [media]="card.media"
                              [showCheckbox]="true"
                              [selected]="isSelected(card)"
                              [invalid]="showListError()"
                              (selectedChange)="onSelectionChange(card, $event)"
                              [testId]="'previous-issue-container-card-' + $index" />
            }
          </div>
        </div>
      </div>

      @for (card of confirmQueue(); track card.issue.identifier; let i = $index) {
        <div class="step-panel"
             [attr.inert]="step() === 'confirm' && currentIndex() === i ? null : ''">
          <app-issue-confirmation [issue]="card.issue"
                                  [media]="card.media"
                                  [currentIndex]="i"
                                  [total]="confirmQueue().length"
                                  [severity]="currentIndex() === i ? currentSeverity() : ''"
                                  [showErrors]="showConfirmErrors() && currentIndex() === i"
                                  (severityChange)="onCardSeverityChange(card, $event)"
                                  (back)="onBack()"
                                  [testId]="step() === 'confirm' && currentIndex() === i ? 'previous-issue-container-confirmation' : 'previous-issue-container-confirmation-' + i" />
        </div>
      }
    </div>
  </div>
  <div class="seperator-border"></div>
      <app-vertical-button-group [buttons]="footerButtons()"
                                 class="previous-issue-container-footer"
                                 testId="previous-issue-container-buttons" />
</app-standard-bottom-sheet>
